// NotFound (404) page strings.
const notfound = {
  code: '404',
  title: 'Page not found',
  text: "The page you were looking for isn't here. It may have moved or never existed.",
  cta: 'Back to home',
};

export default notfound;
